import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { api, errMsg } from "../api";

export default function ResetPassword() {
    const [params] = useSearchParams();
    const navigate = useNavigate();
    const token = params.get("token") || "";
    const [pw, setPw] = useState("");
    const [confirm, setConfirm] = useState("");
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);
    const [done, setDone] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        if (pw !== confirm) { setErr("Passwords don't match"); return; }
        setErr(""); setLoading(true);
        try {
            await api.post("/auth/reset-password", { token, new_password: pw });
            setDone(true);
            setTimeout(() => navigate("/login"), 2500);
        } catch (e) {
            setErr(errMsg(e));
        } finally {
            setLoading(false);
        }
    };

    if (!token) return (
        <div className="max-w-md mx-auto px-5 py-20 text-center" data-testid="reset-no-token">
            <h1 className="font-serif text-2xl text-[var(--ink)] mb-3">Invalid reset link</h1>
            <Link to="/forgot-password" className="btn btn-outline btn-sm">Request a new link</Link>
        </div>
    );

    return (
        <div className="max-w-md mx-auto px-5 py-20" data-testid="reset-password-page">
            <div className="card p-8">
                <h1 className="font-serif text-3xl text-[var(--ink)] mb-1">Set a new password</h1>
                <p className="text-[var(--body)] text-sm mb-6">Pick something at least 6 characters long.</p>
                {done ? (
                    <div className="text-[14px] text-[var(--ink-soft)]" data-testid="reset-success">
                        Password updated. Redirecting to sign in…
                    </div>
                ) : (
                    <form onSubmit={submit} className="space-y-4">
                        <div>
                            <label className="lbl">New password</label>
                            <input className="field" type="password" required minLength={6} value={pw} onChange={(e) => setPw(e.target.value)} data-testid="reset-password-input" />
                        </div>
                        <div>
                            <label className="lbl">Confirm new password</label>
                            <input className="field" type="password" required minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} data-testid="reset-confirm-input" />
                        </div>
                        {err && <div className="text-sm text-[var(--terra)]">{err}</div>}
                        <button className="btn btn-primary w-full" disabled={loading} data-testid="reset-submit">
                            {loading ? "Updating…" : "Update password"}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
